// extracted by mini-css-extract-plugin
export default {"breadcrumb":"mfr-kQ2Ucw_y"};